import * as _4 from 'lodash4';
import * as moment from 'moment';
export interface IAppointmentRequestInformation {
  who: string;
  why: string;
  where: string;
  when: string;
  details: string;
  meetingLink: string;
}
export interface IStudentService {
  id: string;
  name: string;
}
export interface ILocation {
  name: string;
}
export interface IAppointment {
  student_service: IStudentService;
  location: ILocation;
  campaign_note: string;
  end_date: string;
}

export class AppointmentRequestInfoController {
  private appointmentRequestInfo: IAppointmentRequestInformation;
  private appointment: IAppointment;

  $onInit(): void {
    this.appointmentRequestInfo = this._generateAppointmentRequestInformation();
  }

  isPhoneNumber(rawLink: string) {
    return /^\d/g.test(rawLink);
  }

  _generateAppointmentRequestInformation(): IAppointmentRequestInformation {
    const why = _4.get(this.appointment, 'student_service.name', '');
    const where = _4.get(this.appointment, 'location.name', '');
    const when = `Schedule your appointment by ${moment(this.appointment.end_date).format('MMM DD')}`;
    const details = _4.get(this.appointment, 'campaign_note', '');
    const meetingLink = _4.get(this.appointment, 'meeting_url_or_phone', '');
    const who = `${_4.get(this.appointment, 'creator.first_name', '')} ${_4.get(
      this.appointment,
      'creator.last_name',
      ''
    )}`;
    return {
      why,
      when,
      where,
      details,
      who,
      meetingLink
    };
  }
}

export class AppointmentRequestInfoComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-todos/src/components/appointment_request_info/appointment_request_info.html';
  public controller: any = AppointmentRequestInfoController;
  public bindings: any = {
    appointment: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/appointment_request_info/appointment_request_info.ts